import {
  DataIndukVariant,
  PtkStatsByParentWilayahResponse,
  SatpenStatsByParentWilayahResponse,
  YayasanStatsByParentWilayahResponse,
} from '@/apis/types'

import { Container } from '@/components/Container'

import { DATA_INDUK_ROUTE } from '@/configs/constants'

import { ListOfProvinces } from './ListOfProvinces'
import { LastUpdatedAt } from '../LastUpdatedAt'
import { injectImageProvince } from '../../helpers'

export const ListProvinceContainer = ({
  isPending,
  provinceId,
  data,
  additionalParams,
  prefixPath = DATA_INDUK_ROUTE,
  variant = 'satuan-pendidikan',
}: {
  provinceId?: string
  isPending: boolean
  data?:
    | SatpenStatsByParentWilayahResponse
    | YayasanStatsByParentWilayahResponse
    | PtkStatsByParentWilayahResponse
  additionalParams: string
  prefixPath?: string
  variant?: DataIndukVariant
}) => {
  return (
    <section id="table-section" className="bg-white py-4">
      <Container>
        <ListOfProvinces
          provinceId={provinceId}
          isPending={isPending}
          provinces={
            !isPending && data ? injectImageProvince(data.data || []) : []
          }
          additionalParams={additionalParams}
          prefixPath={prefixPath}
          variant={variant}
        />
        {data?.meta?.lastUpdatedAt && (
          <LastUpdatedAt value={data?.meta.lastUpdatedAt} />
        )}
      </Container>
    </section>
  )
}
